import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../flux/Flux';
import ReloadHelper from '../../utils/ReloadHelper';
import ActorStatus from '../SimpleElements/ActorStatus';
import Translations from '../../utils/Translations';

const POP_UP_FAVORITES_LIMIT = 3;
const POP_UP_DIV_ID = 'navBannerPopUp';
const processedActors = [];
let isAfterLogin = false;
let hardReload = false;

class NavbarFavoritesPopUpActor extends Component {
	static pjaxLinkHandler(e) {
		if (e.currentTarget && e.currentTarget.href) {
			ReloadHelper.reloadWithPjax(e.currentTarget.href, e);
		}
	}

	constructor(props) {
		super(props);
		this.state = {
			actorName: '',
			actorPreviewPicture: '',
			actorProfile: '',
			isVisible: false,
		};
		this.onFavoriteActorsChange = this.onFavoriteActorsChange.bind(this);
		this.popFavoriteActors = this.popFavoriteActors.bind(this);
		this.popUpActorOnline = this.popUpActorOnline.bind(this);
		isAfterLogin = this.props.isAfterLogin;
		this.intervalID = -1;

		// to avoid re-popping them after a hard reload
		if (!isAfterLogin) {
			hardReload = true;
		}
	}

	componentDidMount() {
		Flux.Favorite.addActorsChangeListener(this.onFavoriteActorsChange);
		this.intervalID = setInterval(this.popFavoriteActors, 5000);
	}

	componentWillUnmount() {
		Flux.Favorite.removeActorsChangeListener(this.onFavoriteActorsChange);
		if (this.intervalID !== -1) {
			clearInterval(this.intervalID);
		}
	}

	popFavoriteActors() {
		let favoriteActors;
		if (isAfterLogin) {
			favoriteActors = this.props.favoriteActors;
		} else {
			// if websocket is not ready, we keep taking data from props
			favoriteActors = Flux.Favorite.getActors().length > 0 ? Flux.Favorite.getActors() : this.props.favoriteActors;
			if (hardReload) {
				for (const actor of favoriteActors) {
					processedActors.push(actor.name);
				}
				hardReload = false;
			}
		}
		let i = 0;
		let onlineFav = 0;
		for (; i < favoriteActors.length; i++) {
			onlineFav = favoriteActors[i].isOnline ? onlineFav + 1 : onlineFav;
			if (
				favoriteActors[i].isOnline &&
				!favoriteActors[i].isBlocked &&
				((isAfterLogin && processedActors.length < POP_UP_FAVORITES_LIMIT) || !isAfterLogin) &&
				processedActors.indexOf(favoriteActors[i].name) === -1
			) {
				processedActors.push(favoriteActors[i].name);
				this.setState({
					actorName: favoriteActors[i].name,
					actorPreviewPicture: favoriteActors[i].pictureUrl,
					actorProfile: favoriteActors[i].link,
					isVisible: true,
				});
				this.popUpActorOnline();
				break;
			}
		}
		if (
			((isAfterLogin && (processedActors.length >= 3 || onlineFav === processedActors.length)) || !isAfterLogin) &&
			i === favoriteActors.length
		) {
			isAfterLogin = false;
			clearInterval(this.intervalID);
			this.intervalID = -1;
			this.setState({
				isVisible: false,
			});
		}
	}

	onFavoriteActorsChange() {
		// to take into account the case where a model logs in few seconds after your login
		// and only if the time interval does not exist as only one instance should exist
		if (!isAfterLogin && this.intervalID === -1) {
			this.intervalID = setInterval(this.popFavoriteActors, 5000);
		}
	}

	popUpActorOnline() {
		this.setState({
			isVisible: true,
		});
	}

	render() {
		const popUpDivStyle = {
			display: this.state.isVisible ? 'block' : 'none',
		};

		return (
			<div id={POP_UP_DIV_ID} className="dropdown-menu_popup" style={popUpDivStyle}>
				<div className="dropdown-menu__item__table">
					<a href={this.state.actorProfile} onClick={NavbarFavoritesPopUpActor.pjaxLinkHandler} className={'dropdown-menu__item is-online'}>
						<span className="dropdown-menu__item__cell">
							<ActorStatus isActorOnline={true} previewPictureUrl={this.state.actorPreviewPicture} size="sm" />
						</span>
						<span className="dropdown-menu__item__cell -vertical-middle">
							<span className="actor-name -navbar">{this.state.actorName}</span>
							<span className="message-subject -font-small -text-ellipsis">{Translations.get('NavbarActorStatusOnline')}</span>
						</span>
					</a>
				</div>
			</div>
		);
	}
}

NavbarFavoritesPopUpActor.propTypes = {
	favoriteActors: PropTypes.array.isRequired,
	isAfterLogin: PropTypes.bool.isRequired,
};

export default NavbarFavoritesPopUpActor;
